export const ADD_ROW = `ADD_ROW`;
export const ERROR = `ERROR`;
export const SUCCESS = `SUCCESS`;
